(() => {
  let notificationAlreadyTriggered = false;
  const update = (elem) => {
    if (notificationAlreadyTriggered) {
      return;
    }

    const id = elem.getAttribute('data-id');
    const promotion = window.swinger.user.getStudioPromotion(id);

    if (!promotion) {
      return;
    }

    notificationAlreadyTriggered = true;

    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.snackbar.create({
          isSuppressible: true,
          children: [
            {
              component: 'notification',
              data: {
                type: 'info',
                text: i18n('ui.studio.promotion', {
                  promotion: promotion.description,
                }),
              },
            },
          ],
        });
      })
      .catch(console.info);
  };

  window.swinger.observer.initialize('.swinger-studio', (elem) => {
    const itemNumber = elem.getAttribute('data-id');
    if (itemNumber) {
      window.swinger.api.trackLastSeen('studio', itemNumber);
    }

    update(elem);

    document.addEventListener('swinger.user:authchange', () => {
      update(elem);
    }, true);
  }, false);
})();
